import type { State, Props } from './FieldsUpdate.types.tsx';

import { createHigherLevelFieldHook as createHigherLevelFieldHookMain } from './useFieldActions.tsx';

/**
 * @deprecated - Use of createHigherLevelHook is discouraged. Please use RSS createStateHook instead.
 * https://atlassian.github.io/react-sweet-state/#/api/hook?id=createstatehook
 */
export const createHigherLevelFieldHook = <TArg1, TReturnValue>(
	selectorCreator: (arg1: TArg1) => (arg1: State, arg2: Props | undefined) => TReturnValue,
): ((arg1: TArg1) => TReturnValue) =>
	createHigherLevelFieldHookMain<TReturnValue, [TArg1]>(selectorCreator);

/**
 * @deprecated - Use of createHigherLevelHook is discouraged. Please use RSS createStateHook instead.
 * https://atlassian.github.io/react-sweet-state/#/api/hook?id=createstatehook
 */
export const createHigherLevelFieldHook2 = <TArg1, TArg2, TReturnValue>(
	selectorCreator: (
		arg1: TArg1,
		arg2: TArg2,
	) => (arg1: State, arg2: Props | undefined) => TReturnValue,
): ((arg1: TArg1, arg2: TArg2) => TReturnValue) =>
	createHigherLevelFieldHookMain<TReturnValue, [TArg1, TArg2]>(selectorCreator);

/**
 * @deprecated - Use of createHigherLevelHook is discouraged. Please use RSS createStateHook instead.
 * https://atlassian.github.io/react-sweet-state/#/api/hook?id=createstatehook
 */
export const createHigherLevelFieldHook3 = <TArg1, TArg2, TArg3, TReturnValue>(
	selectorCreator: (
		arg1: TArg1,
		arg2: TArg2,
		arg3: TArg3,
	) => (arg1: State, arg2: Props | undefined) => TReturnValue,
): ((arg1: TArg1, arg2: TArg2, arg3: TArg3) => TReturnValue) =>
	createHigherLevelFieldHookMain<TReturnValue, [TArg1, TArg2, TArg3]>(selectorCreator);
